import { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Modal } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { GameCard } from "./GameCard";
import { CertificateCard } from "./CertificateCard";
import MineSweeper from "./games/MineSweeper";
import Tetris from "./games/Tetris";
import FlappyBird from "./games/FlappyBird";
import Snake from "./games/Snake";
import Battleship from "./games/Battleship"
import projImg1 from "../assets/img/react-logo.png";
import projImg2 from "../assets/img/tweedle_logo.gif";
import gameImg1 from "../assets/img/bomb.png";
import gameImg2 from "../assets/img/snake.png";
import gameImg3 from "../assets/img/pinball.png";
import gameImg4 from "../assets/img/flappy-bird.png";
import gameImg5 from "../assets/img/cards.png";
import gameImg6 from "../assets/img/tetris.png";
import gameImg7 from "../assets/img/battleship-logo.png"
import colorSharp2 from "../assets/img/color-sharp2.png";
import TrackVisibility from 'react-on-screen';
import awsImg from "../assets/img/aws.png"

export const Projects = () => {
  const [showModal, setShowModal] = useState(false);
  const [showGameModal, setShowGameModal] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [showCertModal, setShowCertModal] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);
  const [selectedCertName, setSelectedCertName] = useState(null);
  const visitorId = localStorage.getItem("visitorId");

  useEffect(() => {
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      navbar.style.transition = "opacity 0.3s ease";
      navbar.style.opacity = showModal ? "0" : "1";
      setTimeout(() => {
        navbar.style.display = showModal ? "none" : "flex";
      }, showModal ? 300 : 0);
    }
  }, [showModal]);


  const projects = [
    {
      title: "My Portfolio",
      description: "Built using React",
      imgUrl: projImg1,
    },
    {
      title: "Tweedle",
      description: "Wordle-like game built with flask, utilizing X(Twitter) API",
      imgUrl: projImg2,
      url: "https://www.thetweedle.com",
      dbName: "tweedle",
    },
    /*{
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
    },*/
  ];

  const games = [
    {
      title: "Mine Sweeper",
      description: "Avoid the bombs! Classic game built using JavaScript",
      imgUrl: gameImg1,
      dbName: "minesweeper"
    },
    {
      title: "Snake",
      description: "Grow the longest snake! Classic game built with Python",
      imgUrl: gameImg2,
      dbName: "snake"
    },
    /*{
      title: "Pinball",
      description: "Collect the points! Classic game built with Python",
      imgUrl: gameImg3,
      dbName: "pinball"
    },*/
    {
      title: "Flappy Bird",
      description: "Spin off of the classic game built with JavaScript",
      imgUrl: gameImg4,
      dbName: "flappybird"
    },
    /*{
      title: "Black Jack",
      description: "Get to 21! Classic game built with Python",
      imgUrl: gameImg5,
      dbName: "blackjack"
    },*/
    {
      title: "Tetris",
      description: "Beat levels! Classic game built with JavaScript",
      imgUrl: gameImg6,
      dbName: "tetris"
    }, 
    {
      title: "Battleship",
      description: "Slightly different take on the traditional battleship game (JavaScript)",
      imgUrl: gameImg7,
      dbName: "battleship"
    },//ideas: pong, 2048, sudoku, connect four, chess, checkers, solitaire, word search, hangman, memory game
  ];

  const certificates = [
    {
      title: "AWS CDK Getting Started",
      subtitle: "Amazon Web Service Cloud Development Kit: Getting Started Certification",
      description: "Simple course on the basics of development with AWS (benefits and resources of AWS, implementing basic lambda functions, etc.)",
      certPath: "/certificates/AWS_CDK_Getting_Started_Certificate.pdf?zoom=75&pagemode=none",
      imgUrl: awsImg,
    },
  ];

  const handlePaneClick = (title, dbName) => {
    fetch("/api/statistics", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ visitorId, feature: dbName }),
                });
    setSelectedGame(title);
    setShowGameModal(true);
    setShowModal(true);
  };

  const handleCertClick = (title, pdfPath) => {
    setSelectedCertName(title);
    setSelectedCert(pdfPath);
    setShowCertModal(true);
    setShowModal(true);
  };

  const showNav = (showModalFunc) => {
    showModalFunc(false);
    setShowModal(false)
  };


  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Below contains projects that I have completed.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Web Projects</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Some Fun Minigames</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Download Links</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">Certificates</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Row>
                        {
                          games.map((game, index) => {
                            return (
                              <GameCard
                                key={index}
                                {...game}
                                onClick={handlePaneClick}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>None at this time.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="fourth">
                      <Row>
                        {
                          certificates.map((certificate, index) => {
                            return (
                              <CertificateCard
                                key={index}
                                {...certificate}
                                onClick={handleCertClick}
                              />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
      
      {/* Game Modal */}
      <Modal show={showGameModal} onHide={() => showNav(setShowGameModal)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedGame}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGame === "Mine Sweeper" && <MineSweeper />}
          {selectedGame === "Tetris" && <Tetris />}
          {selectedGame === "Flappy Bird" && <FlappyBird />}
          {selectedGame === "Snake" && <Snake />}
          {selectedGame === "Battleship" && <Battleship />}
          {(selectedGame !== "Mine Sweeper" && selectedGame !== "Tetris" && selectedGame !== "Flappy Bird" && selectedGame !== "Snake" && selectedGame !== "Battleship") &&<p>Game not built yet!</p>}
        </Modal.Body>
      </Modal>

      {/* Cert Modal */}
      <Modal show={showCertModal} onHide={() => showNav(setShowCertModal)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedCertName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCert && (
            <iframe
              src={selectedCert}
              title={selectedCertName}
              width="100%"
              height="600px"
              style={{ border: "none" }}
            ></iframe>
          )}
        </Modal.Body>
      </Modal>
    </section>
  )
}